import $ from 'jquery';
import TweenMax from 'gsap/TweenMax';
import AbstractPage from './AbstractPage';

class Change extends AbstractPage {
    constructor(options) {
        super(options);

        const _ = this;

        // _.option
        // _.model
        // _.$wrap

        _._$contents = $('.section-contents', _.$wrap);
        _._$title = $('h2', _._$contents);
        _._$eventWrap = $('.event-img-wrap', _._$contents);
    }

    init(obj = null) {
        super.init(obj);

        const _ = this;

        _._reset();

        return _;
    }

    _startAnimation() {
        const _ = this;

        // if (!_.isAnimated) {
        TweenMax.killTweensOf(_._$contents);
        TweenMax.killTweensOf(_._$title);
        TweenMax.killTweensOf(_._$eventWrap);

        TweenMax.fromTo(
            _._$contents,
            0.8, {
                autoAlpha: 0
            }, {
                scale: 1,
                autoAlpha: 1,
                ease: Expo.easeInOut
            }
        );
        TweenMax.fromTo(
            _._$title,
            1.5, {
                autoAlpha: 0
            }, {
                scale: 1,
                autoAlpha: 1,
                ease: Cubic.easeInOut
            }
        );
        TweenMax.fromTo(
            _._$eventWrap,
            1.2, {
                autoAlpha: 0
            }, {
                delay: 0.65,
                scale: 1,
                autoAlpha: 1,
                ease: Cubic.easeOut
            }
        );

        // }
        // _.isAnimated = true;

        return _;
    }

    _reset() {
        const _ = this;

        // if (_.isAnimated) return;

        TweenMax.killTweensOf(_._$contents);
        TweenMax.killTweensOf(_._$title);
        TweenMax.killTweensOf(_._$eventWrap);

        TweenMax.set(_._$contents, {
            autoAlpha: 0
        });
        TweenMax.set(_._$title, {
            autoAlpha: 0
        });
        TweenMax.set(_._$eventWrap, {
            autoAlpha: 0
        });

        return _;
    }

    enter(obj = null) {
        const _ = this;

        _._startAnimation();

        return _;
    }

    exit(obj = null) {
        const _ = this;

        _._reset();

        return _;
    }

    resize(evt = null) {
        const _ = this;

        return _;
    }

    destroy(obj = null) {
        super.destroy(obj);

        const _ = this;

        return _;
    }
}

export default Change;